import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import { addComment, putComment } from "../../safetySensors/Sensors.actions";
import { ISensorComment } from "../../safetySensors/types";

interface IOpenNewComment {
  open: boolean;
  onClose(): any;
  comment?: ISensorComment;
  closeEditDialog?(): any;
  measuringPointId: number;
}

const getDomainSelector = createSelector(
  (state: IApplicationState) => state.common,
  (commonState) => ({
    domainCode: commonState.selectedDomain?.Code ?? "",
  })
);

export const NewComment = ({
  open,
  onClose,
  comment,
  measuringPointId,
}: IOpenNewComment) => {
  const [text, setText] = useState<string>(comment?.Text || "");
  const { domainCode } = useSelector(getDomainSelector);
  const dispatch = useDispatch();

  const handleNew = () => {
    if (text.length >= 2) {
      const newComment = {
        Text: text,
        Priority: 0,
        RefersTo: { Type: "MeasuringPoint", ID: measuringPointId },
      };

      dispatch(addComment(domainCode, newComment));
      setText("");
      onClose();
    }
  };
  const handleEdit = () => {
    if (text !== comment?.Text) {
      const updatedComment = {
        NodeID: comment?.RefersTo.ID ?? 0,
        Id: comment?.ID ?? 0,
        Text: text,
      };
      dispatch(putComment(domainCode, updatedComment));
      onClose();
    }
  };
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContent>
        <DialogTitle>
          {comment ? t("Edit comment") : t("Add comment")}
        </DialogTitle>

        {!comment ? (
          <TextField
            autoFocus
            minRows={6}
            multiline
            variant="outlined"
            onChange={(event) => setText(event.target.value)}
          />
        ) : (
          <TextField
            value={text}
            minRows={6}
            multiline
            variant="outlined"
            onChange={(event) => setText(event.target.value)}
            autoFocus
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          size="large"
          variant="text"
          onClick={() => onClose()}
        >
          {t("Cancel")}
        </Button>
        <Button
          color="secondary"
          size="large"
          onClick={!comment ? () => handleNew() : () => handleEdit()}
          variant="contained"
        >
          {!comment ? t("Add") : t("Edit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
